import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../app/app-env';
import {oeInterfaceManager} from '../react-oe/oe-interface';
import OEInterfaceAdapter from '../react-oe/oe-interface-adapter';
import OEToolbox from '../lib/tools/oe-toolbox';
import OEInfoViewController from './views/info-view/oe-info-view-controller';

export class OELicensingManager extends React.PureComponent {

    constructor(props) {
        super(props);

        this.props.appComponent.licensingManager = this;

        this.restored = false;
        this.startLicenseValidated = false;

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.waitingControllerConf = {options: {dim: false}};

        this.onLicensingRestore = this.onLicensingRestore.bind(this);
        this.onStartLicenseValidated = this.onStartLicenseValidated.bind(this);
        this.onLicensingProductActivationChanged = this.onLicensingProductActivationChanged.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.licensingRestore, this.onLicensingRestore);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.licensingStartLicenseValidated, this.onStartLicenseValidated);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.licensingProductActivationChanged, this.onLicensingProductActivationChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.licensingRestore, this.onLicensingRestore);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.licensingStartLicenseValidated, this.onStartLicenseValidated);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.licensingProductActivationChanged, this.onLicensingProductActivationChanged);
    }

    addModal(title, msg, buttonFunc, options)  {
        if(this.props.appComponent.module)    this.props.appComponent.module.addModal(title, msg, buttonFunc, options);
    }

    showModalForValidationResult(result)    {
        if(!this.oe.isReady() || result.error === this.oe.Module.LicensingValidationError.noError) return;
        let si = this.oe.sharedInterface;

        let title = si.getLocalizedStringEnc('licensing_alert_validation_failed_title');
        let message = OEToolbox.decode_utf8(result.localizedInfo);
        let buttons = (id, container) => [{title: si.getLocalizedStringEnc('alert_ok'), onClick: () => {container.closeModal(id)}, className: 'btn-primary'}];
        this.addModal(title, message, buttons);
    }

    validateCompletion(errorAlert, callback, waitingControllerConf) {
        let showErrorAlert = typeof(errorAlert) === 'boolean' ? errorAlert : true;

        return function(result) {
            this.props.appComponent.hideWaitingController(waitingControllerConf);

            if(showErrorAlert)  this.showModalForValidationResult(result);
  
            if(typeof(callback) === 'function') callback(result);
        }.bind(this);
    }

    validateBroadcast(key, validationType, errorAlert, callback, waitingControllerConf)  {
        if(!this.oe.isReady()) return;
        let si = this.oe.sharedInterface;
        let controller = si.getUIControllerLicensingManager();

        this.props.appComponent.showWaitingController(waitingControllerConf);
        
        let completion = this.validateCompletion(errorAlert, callback, waitingControllerConf);

        if(typeof(key) === 'string') {
            controller.validateBroadcastWithKey(key, validationType, completion, true);
        } else {
            controller.validateBroadcast(validationType, completion, true);
        }
    }

    validate(product, key, validationType, errorAlert, callback, async, waitingControllerConf)  {
        if(!this.oe.isReady()) return;
        let si = this.oe.sharedInterface;
        let controller = si.getUIControllerLicensingManager();

        this.props.appComponent.showWaitingController(waitingControllerConf);

        let completion = this.validateCompletion(errorAlert, callback, waitingControllerConf);

        let async_ = typeof(async) === 'boolean' ? async : true;

        //
        if(typeof(product) === 'string')    {
            if(typeof(key) === 'string')    {
                controller.validateProductWithKey(product, key, validationType, completion, async_);
            } else {
                controller.validateProduct(product, validationType, completion, async_);
            }
        } else {
            if(typeof(key) === 'string')    {
                controller.validateWithKey(key, validationType, completion, async_);
            } else {
                controller.validate(validationType, completion, async_);
            }
        }
    }

    onLicensingRestore()    {
        if(this.restored)   return;
        this.restored = true;

        let appComponent = this.props.appComponent;
        let si = this.oe.sharedInterface;
        let controller = si.getUIControllerLicensingManager();
        let restoreResult = controller.getRestoreResult();

        if(restoreResult.error !== this.oe.Module.LicensingRestoreResultError.noError && typeof(appComponent.module) === 'object')   {
            let title = si.getLocalizedStringEnc('licensing_alert_restore_failed_title');
            let message = OEToolbox.decode_utf8(restoreResult.localizedInfo);

            let buttons = (id, container) => [
                {title: si.getLocalizedStringEnc('alert_ok'), onClick: () => {container.closeModal(id)}, className: 'btn-primary'},
                {title: si.getLocalizedStringEnc('licensing_alert_manage'), onClick: () => {
                    container.closeModal(id); 

                    if(typeof(appComponent.uiLayer.infoView) === 'object')   {
                        appComponent.uiLayer.infoView.openItem(OEInfoViewController.itemTypes.licensing);
                    }
                    
                }, className: 'btn-primary'}];

            appComponent.module.addModal(title, message, buttons);
        }
    }

    onStartLicenseValidated()   {
        if(this.startLicenseValidated)  return;
        this.startLicenseValidated = true;

        let si = this.oe.sharedInterface;
        let controller = si.getUIControllerLicensingManager();
        let result = controller.getStartLicenseValidationResult();

        if(!result || result.error === this.oe.Module.LicensingValidationError.noError) return;
        this.showModalForValidationResult(result);
    }

    onLicensingProductActivationChanged(message, userInfo)    {
        let si = this.oe.sharedInterface;
        let appComponent = this.props.appComponent;

        const productId = userInfo.productId;
        const isValid = userInfo.isValid;
        const changeReason = userInfo.changeReason;

        if(this.props.config && this.props.config.onLicensingProductActivationChanged)  {
            let fnArray = typeof(this.props.config.onLicensingProductActivationChanged) === 'function' ? [this.props.config.onLicensingProductActivationChanged] : this.props.config.onLicensingProductActivationChanged;
            fnArray.forEach(fn => {
                fn(this, userInfo, this.props.appComponent, this.oe);
            });
        }

        let isActiveProduct = productId === si.getUIControllerLicensingManager().getProductId();
        if(!isActiveProduct)    return;

        if(typeof(appComponent.module) !== 'object') return;

        let strBtnOk = si.getLocalizedStringEnc('alert_ok');
        let strBtnManage = si.getLocalizedStringEnc('licensing_alert_manage');

        if(isValid){
            /*
            let title = si.getLocalizedStringEnc('licensing_activated');
            let message = si.getLocalizedStringEnc('licensing_message_activated');
            let buttons = (id, container) => [{title: strBtnOk, onClick: () => {container.closeModal(id)}, className: 'btn-primary'}];
            appComponent.module.addModal(title, message, buttons);
            */
           return;
        }
        
        if(changeReason === this.oe.Module.LicenseActivationChangeReason.deactivated)    {
            /*
            let title = si.getLocalizedStringEnc('licensing_deactivated');
            let message = si.getLocalizedStringEnc('licensing_message_deactivated');
            let buttons = (id, container) => [{title: strBtnOk, onClick: () => {container.closeModal(id)}, className: 'btn-primary'}];
            appComponent.module.addModal(title, message, buttons);
            */
        } else if(changeReason === this.oe.Module.LicenseActivationChangeReason.sessionExpired)    {
            let title = si.getLocalizedStringEnc('licensing_deactivated');
            let message = si.getLocalizedStringEnc('licensing_message_session_expired');
            
            let buttons = (id, container) => [
                {title: strBtnOk, onClick: () => {container.closeModal(id)}, className: 'btn-primary'},
                {title: strBtnManage, onClick: () => {
                    container.closeModal(id); 

                    if(typeof(appComponent.uiLayer.infoView) === 'object')   {
                        appComponent.uiLayer.infoView.openItem(OEInfoViewController.itemTypes.licensing);
                    }
                    
                }, className: 'btn-primary'}];

            appComponent.module.addModal(title, message, buttons);

        } else {
            let title = si.getLocalizedStringEnc('licensing_deactivated');
            let message = si.getLocalizedStringEnc('licensing_message_license_expired');

            let buttons = (id, container) => [
                {title: strBtnOk, onClick: () => {container.closeModal(id)}, className: 'btn-primary'},
                {title: strBtnManage, onClick: () => {
                    container.closeModal(id); 

                    if(typeof(appComponent.uiLayer.infoView) === 'object')   {
                        appComponent.uiLayer.infoView.openItem(OEInfoViewController.itemTypes.licensing);
                    }
                    
                }, className: 'btn-primary'}];

            appComponent.module.addModal(title, message, buttons);
        }
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.validate(null, null, this.oe.Module.LicenseValidationRequestType.releaseSession, false, null, false, this.waitingControllerConf);
            return;
        }

        let controller = this.oe.sharedInterface.getUIControllerLicensingManager();
        let restoreResult = controller.getRestoreResult();

        if(restoreResult.isSet)    {
            if(this.restored === false)  {
                this.onLicensingRestore();
                this.onStartLicenseValidated();
            } else {
                if(controller.isValid())    {   // we do not want automatic reactivation of manually deactivated licenses at start up
                    this.validate(null, null, this.oe.Module.LicenseValidationRequestType.std, false, null, null, this.waitingControllerConf);
                }
            }
        }
    }

    render() {
        return (
            <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
        );
    }
}

OELicensingManager.defaultProps = {
    moduleId:           'oe-embed'
};

OELicensingManager.propTypes = {
    moduleId:           PropTypes.string,
    config: PropTypes.shape({
        onLicensingProductActivationChanged: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf([PropTypes.func])])
    })
};

export default connectAppEnv((env) => {
    return {
        appComponent:   env.component,
        config:         env.config.module.licensingManager
    };
})(OELicensingManager);